<template>
    <v-form ref="form_detalle_ingreso">
        <v-container fluid grid-list-md>
            <v-row dense>
                <v-col cols="12" sm="4">
                    <v-text-field label="Ingreso Mensual *" color="textbox" v-model="objForm.ingresoMensual"
                        :rules="_.concat(requeridoRegla,decimal)" outlined dense prepend-inner-icon="attach_money">
                    </v-text-field>
                </v-col>
                <v-col cols="12" sm="4">
                    <v-text-field label="Egreso Mensual *" color="textbox" v-model="objForm.egresoMensual"
                        :rules="_.concat(requeridoRegla,decimal)" outlined dense prepend-inner-icon="attach_money">
                    </v-text-field>
                </v-col>
                <v-col cols="12" sm="4">
                    <v-text-field label="Activo *" color="textbox" v-model="objForm.activos"
                        :rules="_.concat(requeridoRegla,decimal)" outlined dense prepend-inner-icon="attach_money">
                    </v-text-field>
                </v-col>
            </v-row>
            <v-row dense>
                <v-col cols="12" sm="4">
                    <v-text-field label="Pasivo *" color="textbox" v-model="objForm.pasivos"
                        :rules="_.concat(requeridoRegla,decimal)" outlined dense prepend-inner-icon="attach_money">
                    </v-text-field>
                </v-col>
                <v-col cols="12" sm="4">
                    <v-text-field label="Patrimonio *" color="textbox" v-model="objForm.patrimonio"
                        :rules="_.concat(requeridoRegla,decimal)" outlined dense prepend-inner-icon="attach_money">
                    </v-text-field>
                </v-col>
                <v-col cols="12" sm="4">
                    <v-text-field label="Otros Ingresos *" color="textbox" v-model="objForm.otrosIngresos"
                        :rules="_.concat(requeridoRegla,decimal)" outlined dense prepend-inner-icon="attach_money">
                    </v-text-field>
                </v-col>
            </v-row>
            <v-row dense>
                <v-col cols="12" sm="12" class="text-right mt-3 mb-3">
                    <v-btn outlined dense rounded color="danger" class="mr-1" @click="previous('objDetalleIng',obDetalle);">Anterior</v-btn>
                    <v-btn rounded dark color="primary" @click="validar">Siguiente</v-btn>
                </v-col>
            </v-row>
        </v-container>
    </v-form>
</template>

<script>
    export default {
        name: 'StepperDetalleIngresoComponent',
        inject: ['previous', 'next'],
        data: () => ({
            obDetalle:{
                opcion: 'LISTAR_DETALLE_INGRESOS'
            }
        }),
        props:{
            cargar:{ type:Boolean, default: false },
            objForm:{ type:Object, default: {} },
            listGeneral:{ type:Object, default: {} },
        },
        watch: {
            cargar(val) {
                if (val && _.size(this.objForm.ingresoMensual) == 0) {
                    this.$set(this,'obDetalle',_.merge({},this.obDetalle, this.objForm));
                    this.objForm.opcion = 'LISTAR_DETALLE_INGRESOS';
                    var keys = ['opcion','idCliente','idFormulario','idProfesion','idEstado'];
                    this.onListar(_.pick(this.obDetalle,keys));
                }
            }
        },
        methods: {
            validar() {
                if (this.$refs.form_detalle_ingreso.validate()) {
                    this.next('objDetalleIng',this.obDetalle);
                }
            },
            onListar(objeto) {
                var error = 'E';
                return axios.post(`${BASE_URI}administrador/prevension-lavado-activo/cliente/listar`, objeto )
                            .then((r) => {
                                if (_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                                if (_.size(_.get(r,['data','data'],[])) == 0) { error = 'I'; throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion); }
                                    this.$set(this,'obDetalle',_.merge({},this.obDetalle, r.data.data[0]));
                            })
                            .catch((e)=>{
                                mensajesAlerta(e, error);
                            });
            }
        }
    }
</script>

<style>

</style>